import React from 'react'
import { MenuItem } from '@mui/material'
import { Status } from '../../__generated__/graphql'
import TransformDisplayToEdition from '../form/TransformDisplayToEdition'
import { StatusStyled } from '../StatusStyled'
import { useAppTranslations } from '../../utils/hooks/useAppTranslations'

export const ArchiveEntityStatusField: React.FC<{
  status: Status
  editable: boolean
  name?: string
}> = ({ status, editable, name = 'status' }) => {
  const t = useAppTranslations()

  return (
    <TransformDisplayToEdition
      editable={editable && status !== Status.Archived}
      inputType="select"
      label="commons.status"
      name={name}
      required
      text={status}
      toDisplay={<StatusStyled status={status} />}
      withNone={false}
    >
      <MenuItem value={Status.Inactive}>{t('commons.inactive')}</MenuItem>
      <MenuItem value={Status.Archived}>{t('commons.archived')}</MenuItem>
    </TransformDisplayToEdition>
  )
}
